"use client";

import { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY as string,
);

const StripeButton = () => {
  const [amount, setAmount] = useState(10);
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    setLoading(true);

    const response = await fetch("/api/stripe/checkout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount }),
    });

    const { id } = await response.json();
    const stripe = await stripePromise;

    if (stripe) {
      await stripe.redirectToCheckout({ sessionId: id });
    }

    setLoading(false);
  };

  return (
    <div className="mt-6 text-center">
      <input
        type="number"
        min="1"
        value={amount}
        onChange={(e) => setAmount(Number(e.target.value))}
        className="w-24 rounded-lg border p-2 text-center"
      />
      <button
        onClick={handleCheckout}
        disabled={loading}
        className="ml-3 rounded-lg bg-green-600 px-6 py-3 text-white hover:bg-green-800"
      >
        {loading ? "Redirection..." : "Payer par CB"}
      </button>
    </div>
  );
};

export default StripeButton;
